<template>
  <div class="boybox">
    <div class="box">
      <div class="box1">
        <p class="title">{{ $t("hp4.mainTitle") }}</p>
        <div class="desc-row">
          <p class="desc">{{ $t("hp4.subtitle") }}</p>
          <div class="carousel-controls">
            <button
              class="arrow-btn left"
              :class="{ active: activeArrow === 'left' }"
              @click="prevSlide"
              aria-label="Previous"
            ></button>
            <button
              class="arrow-btn right"
              :class="{ active: activeArrow === 'right' }"
              @click="nextSlide"
              aria-label="Next"
            ></button>
          </div>
        </div>
      </div>
      <el-carousel
        ref="hp4Carousel"
        :interval="4000"
        type="card"
        :height="carouselHeight"
      >
        <el-carousel-item v-for="(img, i) in images" :key="i">
          <div class="card-inner">
            <img
              :src="img"
              alt="slide"
              style="
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
              "
            />
            <div class="gradient-mask"></div>
            <div class="corner-text">{{ currentCaptions[i] }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      images: [
        require("@/assets/img/homePage/a1.jpg"),
        require("@/assets/img/homePage/a2.jpg"),
        require("@/assets/img/homePage/a3.jpg"),
        require("@/assets/img/homePage/a6.png"),
      ],
      captionsI18n: {
        en: [
          "Initiate and track refunds with ease",
          "View and manage settlements in one place",
          "Set up discounts and zero-interest EMl options",
          "Access real-time analytics and customizable reports",
        ],
        ur: [
          "رقوم کی واپسی آسانی سے شروع کریں اور ٹریک کریں",
          "تمام سیٹلمنٹس کو ایک جگہ دیکھیں اور منظم کریں",
          "ڈسکاؤنٹس اور بغیر سود والے اقساط ترتیب دیں",
          "حقیقی وقت کی تجزیات اور حسبِ ضرورت رپورٹس تک رسائی",
        ],
      },
      activeArrow: "right",
    }
  },
  computed: {
    currentCaptions() {
      const locale = this.$i18n?.locale || "en"
      return this.captionsI18n[locale] || this.captionsI18n.en
    },
    carouselHeight() {
      return "clamp(180px, 28vw, 320px)"
    },
  },
  methods: {
    prevSlide() {
      if (this.$refs.hp4Carousel && this.$refs.hp4Carousel.prev) {
        this.$refs.hp4Carousel.prev()
      }
      this.activeArrow = "left"
    },
    nextSlide() {
      if (this.$refs.hp4Carousel && this.$refs.hp4Carousel.next) {
        this.$refs.hp4Carousel.next()
      }
      this.activeArrow = "right"
    },
  },
}
</script>

<style scoped>
.boybox {
  width: 100%;
  min-height: 80vh;
  padding: clamp(60px, 8vw, 130px) clamp(16px, 8vw, 400px);
  /* background-color: #bbb7b7; */
}
.box {
  max-width: 1200px;
  margin: 0 auto;
}
.box1 {
  width: 100%;
  height: 300px;
}
.title {
  width: 100%;
  max-width: 931px;
  font-family: Arial;
  font-weight: bold;
  font-size: clamp(28px, 5vw, 44px);
  color: #0f0318;
  line-height: 1.2;
}
.desc-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.desc {
  margin-top: 24px;
  width: 100%;
  max-width: 931px;
  font-family: Arial;
  font-weight: bold;
  font-size: clamp(16px, 2.8vw, 24px);
  color: #3252cd;
  line-height: 1.5;
}
.carousel-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 16px;
  direction: ltr;
}
.arrow-btn {
  width: clamp(28px, 5vw, 36px);
  height: clamp(28px, 5vw, 36px);
  border-radius: 50%;
  border: 2px solid #cfd3dc;
  background: #fff;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}
.arrow-btn:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: clamp(8px, 1.5vw, 10px);
  height: clamp(8px, 1.5vw, 10px);
  border: solid #8b8fa3;
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -50%) rotate(135deg);
}
.arrow-btn.right:before {
  transform: translate(-50%, -50%) rotate(-45deg);
}
.arrow-btn.active {
  background: #e9efff;
  border-color: #b9c6ff;
}
.arrow-btn.active:before {
  border-color: #3b63ff;
}
.arrow-btn.left:hover,
.arrow-btn.right:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
/* 让轮播整体向下移动 */
.el-carousel {
  margin-top: -80px;
}
/* 隐藏指示点 */
::v-deep .el-carousel__indicators {
  display: none !important;
}
/* 让卡片圆角并裁剪内部内容 */
::v-deep .el-carousel__item {
  border-radius: 16px;
  overflow: hidden;
}
/* 文字叠加定位 */
.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
}
.gradient-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(50, 82, 205, 0.75) 0%,
    rgba(50, 82, 205, 0.6) 30%,
    rgba(50, 82, 205, 0) 70%
  );
  pointer-events: none;
  z-index: 1;
}
.corner-text {
  position: absolute;
  left: 12px;
  bottom: 20px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: clamp(14px, 2.6vw, 24px);
  line-height: 1.4;
  color: #fff;
  max-width: 70%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  z-index: 2;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

@media (max-width: 992px) {
  .el-carousel {
    margin-top: -80px;
  }
}

@media (max-width: 768px) {
  .boybox {
    padding: clamp(40px, 10vw, 80px) clamp(12px, 5vw, 24px);
    min-height: auto;
  }
  .box1 {
    height: auto;
  }
  .desc-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .carousel-controls {
    margin-left: 0;
    margin-top: 12px;
  }
  .desc {
    margin-top: 8px;
  }
  .corner-text {
    max-width: 85%;
  }
  .el-carousel {
    margin-top: 0;
    height: 160px !important;
  }
  ::v-deep .el-carousel__container {
    height: 160px !important;
  }
}
</style>
